module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exam_detail_box"
  }, [_c('div', {
    staticClass: "bg_box"
  }), _vm._v(" "), _c('div', {
    staticClass: "exam_detail_top"
  }, [_c('div', {
    staticClass: "exam_msg_t"
  }, [_c('p', {
    staticClass: "exam_msg_tl"
  }, [_vm._v(_vm._s(_vm.examinfoData.title))])]), _vm._v(" "), _c('div', {
    staticClass: "exam_msg_b"
  }, [(_vm.examinfoData.startTime || _vm.examinfoData.endTime) ? _c('p', [_vm._v("报名时间：" + _vm._s(_vm.examinfoData.startTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : _vm.examinfoData.startTime.substring(0, 16)) + "~" + _vm._s(_vm.examinfoData.endTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : _vm.examinfoData.endTime.substring(0, 16)))]) : _vm._e(), _vm._v(" "), (_vm.examinfoData.doTime) ? _c('p', [_vm._v("考试时间：" + _vm._s(_vm.examinfoData.doTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : _vm.examinfoData.doTime.substring(0, 16)))]) : _vm._e(), _vm._v(" "), (_vm.examinfoData.checkTime) ? _c('p', [_vm._v("查询时间：" + _vm._s(_vm.examinfoData.checkTime.substring(0, 16) == '1970-01-01 08:00' ? '不详' : _vm.examinfoData.checkTime.substring(0, 16)))]) : _vm._e(), _vm._v(" "), (_vm.examinfoData.isRemind) ? _c('p', [_vm._v("提醒方式：" + _vm._s(_vm.examinfoData.remindType))]) : _vm._e()]), _vm._v(" "), (!_vm.examinfoData.isRemind) ? _c('div', {
    staticClass: "exam_msg_link"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.remindcheck()
      }
    }
  }, [_vm._v("加入我的日历")])]) : _c('div', {
    staticClass: "exam_msg_link"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.delremindcheck(_vm.examinfoData.id)
      }
    }
  }, [_vm._v("取消加入我的日历")])])]), _vm._v(" "), _c('div', {
    staticClass: "exam_detail_bottom"
  }, [_c('ul', {
    staticClass: "exam_type_top_box"
  }, _vm._l((_vm.infoTypeData), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'act': index == _vm.typeact
      },
      on: {
        "click": function($event) {
          return _vm.checkTypetab(item.id, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "exam_type_bottom_box"
  }, _vm._l((_vm.infoTypesData), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'act': index == _vm.typesact
      },
      on: {
        "click": function($event) {
          return _vm.checkTypestab(item.id, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "exam_type_list_box"
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了",
      "immediate-check": false
    },
    on: {
      "load": _vm.getExamDetail
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "examlist",
      on: {
        "click": function($event) {
          return _vm.gotodetailinfo(item.id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n          ")])
  }), 0)], 1)]), _vm._v(" "), _c('tab-bar', {
    attrs: {
      "current-index": 0
    }
  }), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "round": "",
      "position": "bottom",
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.remindPop),
      callback: function($$v) {
        _vm.remindPop = $$v
      },
      expression: "remindPop"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.columns,
      "title": "提醒设置"
    },
    on: {
      "cancel": function($event) {
        _vm.remindPop = false
      },
      "confirm": _vm.remindChoose
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2f96b932"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/detail.vue
// module id = 694
// module chunks = 1